// extracted by css-extract-rspack-plugin
export default {"FloatingButton":"fv6kX"};